import type { PropsWithChildren } from 'react'
import { Container } from '@mote/ui/components'
import styled, { th } from '@xstyled/styled-components'
import { Footer, Header } from './shared'

export const CheckoutLayout = ({
  children
}: PropsWithChildren): JSX.Element => {
  return (
    <Root>
      {/* @ts-expect-error */}
      <Header hideNavContent />
      <Container variant='narrow'>{children}</Container>
      {/* @ts-expect-error */}
      <Footer variant='minimal' />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
  background: ${th.color('grey.l4')};
`
